import type { Agent } from '@/lib/types';

/**
 * Body copy for the "delete this agent" confirmation.
 *
 * Names the sandbox teardown only when the run actually has one, so an agent
 * that never got a devbox does not warn about losing work that cannot exist.
 */
export function deleteAgentDescription(agent: Pick<Agent, 'devboxId'>): string {
  return agent.devboxId
    ? 'This permanently deletes the agent and tears down its sandbox, including any work on it you have not pushed. This cannot be undone.'
    : 'This permanently deletes the agent and its history. This cannot be undone.';
}
